/**
 * Single source of truth for the onboarding journey (plan §9).
 * Shared by the OnboardingRibbon and the facility setup pages so the
 * step order, labels and deep-link routes never drift apart.
 */
export const ONBOARDING_STEPS = [
  { id: 'set_password', label: 'Secure your account', short: 'Password', route: '/dashboard/profile' },
  { id: 'location', label: "Pin your ground's location", short: 'Location', route: '/dashboard/facility-location' },
  { id: 'resources', label: 'Add your ground & services', short: 'Services', route: '/dashboard/facility-services' },
  { id: 'slots', label: 'Set timings & slot prices', short: 'Timings & Prices', route: '/dashboard/facility-services' },
  { id: 'first_booking', label: 'Record your first booking', short: 'First booking', route: '/dashboard/book-now' },
];

/** Build a deep link that keeps the guided-onboarding context attached. */
export const onboardingHref = (step) =>
  `${step.route}?onboarding=1&step=${step.id}`;
